export default "__VITE_ASSET__BcIJ5WAK__"